"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Content = exports.ControlBar = exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = exports.App = function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, App);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(App).apply(this, arguments));
	}

	_createClass(App, [{
		key: "findChild",
		value: function findChild(type) {
			if (!this.props.children || !this.props.children.reduce || !this.props.children.reduce.call) {
				return null;
			}
			return this.props.children.reduce(function (topBar, element) {
				if (element.type === type) {
					return element;
				} else {
					return topBar;
				}
			}, null);
		}
	}, {
		key: "render",
		value: function render() {
			// re-structure the content and topbar elements to what css expects
			var topBar = this.findChild(ControlBar);
			var content = this.findChild(Content);

			if (content && topBar) {
				content = _react2.default.cloneElement(content, { topBar: topBar });
			}
			var children = this.props.children.filter(function (element) {
				return element.type !== ControlBar && element.type !== Content;
			});
			children.push(content);
			return _react2.default.createElement(
				"div",
				{ id: "content", role: "main", className: "app-" + this.props.appId },
				children
			);
		}
	}]);

	return App;
}(_react.Component);

var ControlBar = exports.ControlBar = function (_Component2) {
	_inherits(ControlBar, _Component2);

	function ControlBar() {
		_classCallCheck(this, ControlBar);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(ControlBar).apply(this, arguments));
	}

	_createClass(ControlBar, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ id: "controls" },
				this.props.children
			);
		}
	}]);

	return ControlBar;
}(_react.Component);

var Content = exports.Content = function (_Component3) {
	_inherits(Content, _Component3);

	function Content() {
		_classCallCheck(this, Content);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(Content).apply(this, arguments));
	}

	_createClass(Content, [{
		key: "render",
		value: function render() {
			var className = this.props.className || '';
			var topBar = this.props.topBar;
			if (topBar) {
				className = className + ' hascontrols';
			} else {
				topBar = [];
			}
			return _react2.default.createElement(
				"div",
				{ id: "app-content" },
				topBar,
				_react2.default.createElement(
					ContentContainer,
					{ className: className.trim() },
					this.props.children
				)
			);
		}
	}]);

	return Content;
}(_react.Component);

var ContentContainer = function (_Component4) {
	_inherits(ContentContainer, _Component4);

	function ContentContainer() {
		_classCallCheck(this, ContentContainer);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(ContentContainer).apply(this, arguments));
	}

	_createClass(ContentContainer, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: this.props.className, id: "content" },
				this.props.children
			);
		}
	}]);

	return ContentContainer;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./~/oc-react-components/build/App.js
// module id = 508
// module chunks = 0